export const combinedVisits = false;
export const productStatement = true;